import { useApiClient } from '@/app/core/api-client';
import type { Guard } from './interfaces';

export const authGuard: Guard = () => {
  return useApiClient().auth.isAuthenticated()
    ? true
    : {
        name: 'auth',
      };
};
